<template>
  <div class="whole orders">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
<!--        <el-date-picker style="float: left;" v-model="startDate" type="date" placeholder="请选择开始日期">-->
<!--        </el-date-picker>-->
<!--        <el-date-picker style="float: left;" v-model="endDate" type="date" placeholder="请选择截止日期"></el-date-picker>-->
<!--        <el-select placeholder="请选择订单状态" v-model="state" style="float: left;">-->
<!--          <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"/>-->
<!--        </el-select>-->
<!--        <el-input v-model="keywords" placeholder="请输入关键字" style="float: left;"></el-input>-->
<el-button @click="exportByOrderType" type="primary" >导出</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
          @current-change="pageChange" :total="totalNum" v-if="paginationShow">
        </el-pagination>
        
      </div>
      <div class="userTable">
        <el-table :data="orders" style="width: 100%;margin-bottom: 20px;"
          row-key="id" border default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column prop="orderNumber" label="订单编号" width="210"/>
          <el-table-column prop="insertTime" label="下单时间" width="210"/>
           <!-- <el-table-column prop="state" label="订单状态" width="150" /> -->
           <el-table-column label="订单状态" width="150">
            <template slot-scope="scope">
              {{ statusMappings[scope.row.state] || "" }}
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称" width="150"/>
          <el-table-column prop="specialSpec" label="规格" width="150"/>
          <el-table-column prop="number" label="数量" width="100"/>
          <el-table-column prop="unitPrice" label="单价" width="100"/>
          <el-table-column prop="totalPrices" label="消费金额" width="210"/>
          <el-table-column prop="distributionCode" label="配送码" width="210"/>
          <el-table-column prop="logisticsFee" label="自提服务费" width="210"/>
          <el-table-column prop="contactName" label="联系人" width="210"/>
          <el-table-column prop="contactPhone" label="联系电话" width="210"/>
          <el-table-column prop="userName" label="下单人" width="210"/>
          <el-table-column prop="storeName" label="门店名称" width="210"/>
          <el-table-column prop="storeAddress" label="门店地址" width="210"/>

<!--          <el-table-column prop="payWay" label="支付方式" width="210"/>-->
<!--          <el-table-column props='payWay' label="支付方式" width="210">-->
<!--          <el-table-column props='payWay' label="支付方式" width="210">-->
<!--            <template scope="scope">-->
<!--              <div>{{getPayWay(scope)}}</div>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getStorePickOrderList,exportByOrderType} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      token:window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      keywords:"",
      storeOrderType:"2",
      type: 3,
      orders:[],
      statusMappings: {
        601: "待配送",
        603: "已收货",
        604: "已评价",
        101: "待支付",
        301: "待发货",
        201: "待自提",
        202: "已自提",
        203: "已评价",
        302: "待收货"
      }
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this._getList();
    }
  },
  methods: {
    exportByOrderType() {
    	location.href = exportByOrderType+'type='+this.type+"&startDate="+this.formatDate(this.startDate)+"&endDate="+this.formatDate(this.endDate)+"";
    },
    pageChange (val) {
      this.pageNum = val
      this._getList()
    },
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        state: "",
        startDate: "",
        endDate: "",
        content: this.keywords,
        storeId: "",
        storeOrderType: this.storeOrderType,
      }
      loadingInstance(Loading)
      getStorePickOrderList(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.totalNum = res.data.total
          this.orders = res.data.records.map(item=>{
            let oneOrder = {
              id:item.orderNumber,
              orderNumber:item.orderNumber,
              insertTime:item.insertTime,
              productName:"",
              state: "",
              number:"",
              unitPrice:"",
              totalPrices:"",
              logisticsFee:"",
              userName:item.userName,
              storeName:item.umStoreVo.name,
              storeAddress:item.umStoreVo.detailed,
              contactName:item.contactName,
              contactPhone:item.contactPhone,
              level:1,
              distributionCode:item.distributionCode
            }
            oneOrder.children = item.orderItemVos.map(c=>{
              return {
                id:c.itemNumber,
                orderNumber:"",
                insertTime:"",
                productName:c.umSkuVo.title,
                state: c.state,
                number:c.number,
                unitPrice:c.unitPrice,
                totalPrices:c.totalPrices,
                logisticsFee:c.logisticsFee,
                userName:c.userName,
                storeName:c.storeName,
                storeAddress:c.storeAddress,
                specialSpec:c.umSkuVo.specialSpec,
                level:2
              }
            })
            return oneOrder;
          })
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    },
    formatDate(date) {
    	if (date != null && date != 'null' && date != undefined) {
    		date = new Date(Date.parse(date)); //转换成Data();
    		var y = date.getFullYear();
    		var m = date.getMonth() + 1;
    		m = m < 10 ? '0' + m : m;
    		var d = date.getDate();
    		d = d < 10 ? ('0' + d) : d;
    		return y + '-' + m + '-' + d;
    	} else {
    		return "";
    	}

    }
  },
}
</script>
<style scoped>
.orders .product-img{
  width: 90px;
}

.user{
  z-index: 9;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #F8F8F8;
}
.userOperate{
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.userTable{
  padding: 10px;
  position: relative;
}
</style>
<style>
.orders table tr.el-table__row--level-0{
  background-color: #f7e7e7 !important;
}
.userOperate .el-input {
  width:180px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.userOperate .el-button {
  width:100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/storeOrder/pagePsPick.vue